import { render } from "./ViewsReturn.vue?vue&type=template&id=79fe370e"
import script from "./ViewsReturn.vue?vue&type=script&lang=js"
export * from "./ViewsReturn.vue?vue&type=script&lang=js"

import exportComponent from "D:\\a\\1\\s\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__